import { ChangeEvent } from 'react';
import { Row, Col, Table, Spinner, Button, ButtonGroup } from 'react-bootstrap';
import { RosterEntry } from '../../../models/interfaces/RosterEntry';
import { SportProvider } from '../../../models/interfaces/SportProvider';
import { ChangePlayerCapProps } from './MatchPlayerView';

interface Props {
    teamName: string;
    changePlayerCapProps: ChangePlayerCapProps | undefined;
    team: 'light' | 'dark';
    cancelCapChange: (team: 'light' | 'dark') => void;
    handleSubmit: (team: 'light' | 'dark') => void;
    submitting: boolean;
    playerList: RosterEntry[] | undefined;
    handleCapChange: (
        e: ChangeEvent<HTMLSelectElement>,
        team: 'light' | 'dark',
        player: RosterEntry
    ) => void;
    sportProvider: SportProvider;
}

const ChangeCapTeamCol = ({
    teamName,
    changePlayerCapProps,
    team,
    cancelCapChange,
    handleSubmit,
    submitting,
    playerList,
    handleCapChange,
    sportProvider,
}: Props) => {
    return (
        <Col className="text-center">
            <Row>
                <Col>
                    {changePlayerCapProps ? (
                        <>
                            <Row>
                                <Col>
                                    {`Update ${changePlayerCapProps.player.name.firstName} ${changePlayerCapProps.player.name.lastName} from #${changePlayerCapProps.player.capNumber.displayName} to #${changePlayerCapProps.newCapNumber.displayName}`}
                                </Col>
                            </Row>
                            <Row className="my-2">
                                <Col>
                                    <ButtonGroup>
                                        <Button
                                            onClick={() => cancelCapChange(team)}
                                            variant="outline-primary"
                                            disabled={submitting}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="success"
                                            onClick={() => handleSubmit(team)}
                                            disabled={submitting}
                                        >
                                            {submitting ? (
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                            ) : (
                                                'Confirm'
                                            )}
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </>
                    ) : playerList ? (
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Player Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {playerList.map((player) => (
                                    // capNumber needs to be included in the key so that when a new number is submitted the row will also update
                                    <tr key={`${player.id}-${player.capNumber.databaseValue}`}>
                                        <td>
                                            <select
                                                id={`cap-${player.id}`}
                                                onChange={(e) => handleCapChange(e, team, player)}
                                                defaultValue={player.capNumber.databaseValue}
                                            >
                                                {sportProvider.playerCapNumbers.map((capNumber) => (
                                                    <option
                                                        key={capNumber.databaseValue}
                                                        value={capNumber.databaseValue}
                                                    >
                                                        {capNumber.displayName}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>{`${player.name.firstName} ${player.name.lastName}`}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    )}
                </Col>
            </Row>
        </Col>
    );
};

export default ChangeCapTeamCol;
